import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import {Button} from "@material-ui/core";
import React from "react";
import styles from "./components.module.scss";

const LeftHandedModal = ({onCloseButtonClick}: { onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>
                    Are you left-handed?
                </div>
                <CrossButtonBlack
                    className={clsx("no-fastclick", styles.crossButtonDark)}
                    onClick={onCloseButtonClick}
                />
            </div>
            <div className={styles.description}>
                Some dental offices have their operatories set up in a way that makes it very difficult for left-handed clinicians to work.
                <br/><br/>
                Let us know if you are left-handed and we’ll help you avoid a really awkward day.
            </div>
            <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx("bigButtonInNewStyle")}
            >
                OK
            </Button>
        </>
    );
}

export default LeftHandedModal;